import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { type PackagePickerStoreSlice } from '../../../../redux/packagePicker/types';
import s from './SaleCountdown.scss';

export interface Props {
  sale: PackagePickerStoreSlice['sale'];
}

const getRemainingTime = (endDate: Date) => {
  let remainingTime;
  const diff = +new Date(endDate) - +new Date();
  if (diff > 0) {
    remainingTime = {
      days: Math.floor(diff / (1000 * 86400)),
      hours: Math.floor((diff / (1000 * 3600)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }
  return remainingTime;
};

const SaleCountdown: React.FC<Props> = ({ sale }) => {
  const { t } = useTranslation();
  const saleEnd = new Date(sale!.saleEndDate ?? 0);
  const [timeLeft, setTimeLeft] = useState(getRemainingTime(saleEnd));
  const timeParts: React.ReactNode[] = [];

  useEffect(() => {
    setTimeout(() => setTimeLeft(getRemainingTime(saleEnd)), 1000);
  });

  if (!sale || !timeLeft) {
    return null;
  }
  Object.keys(timeLeft).forEach(interval => {
    if (interval === 'days' && !timeLeft[interval]) {
      return;
    }
    timeParts.push(
      <div key={`interval-${interval}`} className={s['interval']}>
        <span className={s['interval-value']}>
          {interval === 'days'
            ? timeLeft[interval]
            : `00${timeLeft[interval]}`.slice(-2)}
        </span>
        <span className={s['interval-type']}>
          {t(`packagePicker.saleCountdown.time.var.${interval}`)}
        </span>
      </div>
    );
    if (interval !== 'seconds') {
      timeParts.push(
        <div key={`divider-${interval}`} className={s['interval-divider']}>
          :
        </div>
      );
    }
  });
  return (
    <div className={s['root']}>
      <span className={s['prefix']}>
        <Trans i18nKey="packagePicker.saleCountdown.salePrefix">
          The <strong>{sale.discountValuePercent}% Off Sale</strong> ends in
        </Trans>
      </span>
      <div className={s['intervals']}>{timeParts}</div>
    </div>
  );
};
SaleCountdown.displayName = 'SaleCountdown';

export default SaleCountdown;
